<div
  class="account-item"
  [class.account-item-padding-bottom]="!lastInList"
  [class.accounts-border-bottom]="!lastInList">
  <div class="d-flex flex-column gap-2">
    <span class="account-name">{{ account | accountDisplayName }}</span>
    <span class="account-id">{{ account.id }}</span>
  </div>
  <span class="title-sm">{{ account.totalBalance | currency }}</span>
</div>
